export default {
    corporate_accounts: (state) => state.corporate_accounts,
    upload_payments_receipts: (state) => state.receipts,
    get_active_subscription: (state) => state.company_subscriptions.filter((elm)=> elm.status === "active"),
    get_inactive_subscription: (state) => state.company_subscriptions.filter((elm)=> elm.status === "inactive" )
  };
  